import React, {FC} from "react"

import {LegacyNotificationCard, useContentCardActions} from "@irati/braze"
import timeCreated from "@irati/braze/utils/timeCreated"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Button from "@irati/ui/src/Button"
import {getDomain} from "@irati/utils/links"
import authentication from "@irati/auth"
import tracking from "@irati-tracking/content-cards"

import CardImage from "../CardImage"
import {CardContainer, InfoContainer, Title, Description, PinnedWrapper, TimeCreated, Cta, CustomLink} from "./styled"

interface Props {
  card: LegacyNotificationCard
}

const ClassicContentCard: FC<Props> = ({card}) => {
  const {extras, pinned, imageUrl, linkText, created, updated, title, url, clicked} = card
  const time = created || updated
  const isInternalUrl = url?.includes(getDomain(authentication.business().subdomain))
  /** This is a patch applied to make sure cta will be displayed only if is set from braze */
  const shouldDisplayCta = linkText && !url?.includes(linkText)
  const {markContentCardClicked} = useContentCardActions()

  const handleCardClick = () => {
    tracking.clickContentCard({
      type: pinned ? "pinned" : "standard",
      unread: !card.viewed,
      campaign_name: extras?.campaign_name,
      entity_id: extras?.entity_id,
      perkbox_product: extras?.perkbox_product
    })

    markContentCardClicked(card.id)
  }

  return (
    <CustomLink plain target={isInternalUrl ? "_self" : "_blank"} href={url} onClick={handleCardClick}>
      <CardContainer pinned={pinned} backgroundImage={extras?.background} clicked={clicked}>
        <CardImage url={imageUrl} type={extras?.image_shape} productBadge={extras?.badge} />
        <InfoContainer>
          <Title>{title}</Title>
          <Description small>{card.description}</Description>
          {shouldDisplayCta && (
            <Cta>
              <Button small>{linkText}</Button>
            </Cta>
          )}
        </InfoContainer>
        {pinned ? (
          <PinnedWrapper>
            <Icon icon={IconTypes.pinned} size={60} />
          </PinnedWrapper>
        ) : (
          <TimeCreated>{time && timeCreated(time.getTime() / 1000)}</TimeCreated>
        )}
      </CardContainer>
    </CustomLink>
  )
}

export default ClassicContentCard
